import { selectionContainsListType } from '../Toolbar/components/Format/components/ToggleListPane/utils'
import { unwrapList, turnIntoToggleList } from '.'
import { type EditorView } from 'prosemirror-view'
import { TextSelection } from 'prosemirror-state'

/**
 * If the selection consists of a toggle_list, unwrap it (extracting the summary and contents)
 * Otherwise, turn the selection into a toggle_list as normal
 */
export const toggleToggleList = (view: EditorView) => {
  const { state } = view
  const { contains: toggleBlockSelected, exclusive: toggleBlockExclusive } = selectionContainsListType(
    state,
    state.schema.nodes.toggle_list,
  )
  const isInsideToggleBody =
    state.selection instanceof TextSelection &&
    state.selection.empty &&
    state.selection.$anchor.node(-1)?.type === state.schema.nodes.toggle_list
  if (toggleBlockSelected && toggleBlockExclusive && !isInsideToggleBody) {
    unwrapList(view, state.schema.nodes.toggle_list)()
  } else {
    turnIntoToggleList(view)()
  }
}
